import { Route } from "./routes";

export interface GetPathItems {
	[key: string]: string | number | undefined;
}

/**
 * Utility to replace the ids in a path. For example, if the path is
 * `/groups/view/:groupId` and the id is `123`, the path will be
 * `/groups/view/123`.
 *
 * Example usage:
 *
 * ```ts
 * const path = getPath(routes._.groups.view, { groupId: 123 });
 * ```
 *
 * @param route
 * @param items The items to replace in the path, and their values.
 * @returns
 */
export const getPath = (route: Route, items: GetPathItems): string => {
	// convert the keys of `items` to be lowercase
	const itemsLower = Object.keys(items).reduce((acc, key) => {
		acc[key.toLowerCase()] = items[key];
		return acc;
	}, {} as GetPathItems);

	return route.path
		.split("/")
		.map((part) => {
			if (!part.startsWith(":")) {
				return part;
			}

			const key = part.toLowerCase().slice(1);
			const value = itemsLower[key];

			if (value) {
				return value;
			}

			return "";
		})
		.join("/");
};
